<template lang="pug">
  div(class="locus-block")
    section-title(title="SMOUTの軌跡")
    div(class="list")
      div(class="item")
        div(class="card")
          img(src="~images/Event/Infographics/popscore@2x.png")
          div(class="cardLabel")
            | ネット関係人口スコア公開
            br
            | （2018/6/14）
      div(class="item")
        div(class="card")
          img(src="~images/Event/Infographics/lab@2x.png")
          div(class="cardLabel")
            | 移住研究所リリース
            br
            | （2018/12/13）
      div(class="item")
        div(class="card")
          img(src="~images/Event/Infographics/slot@2x.png")
          div(class="cardLabel")
            | 移住スロットリリース
            br
            | （2019/1/1）
      div(class="item")
        div(class="card")
          img(src="~images/Event/Infographics/first_anniversary@2x.png")
          div(class="cardLabel")
            | 24時間オンライン移住相談イベント開催
            br
            | （2019/6/4）
      div(class="item")
        div(class="card")
          img(src="~images/Event/Infographics/mystery_ticket@2x.png")
          div(class="cardLabel")
            | ミステリーチケットイベント開催
            br
            | （2019/11/11）
      div(class="item")
        div(class="card")
          img(src="~images/Event/Infographics/onlinesalon@2x.png")
          div(class="cardLabel")
            | 地域資本主義サロン開始
            br
            | （2019/12/10）

</template>
<script>
  import SectionTitle from 'modules/components/Event/Infographics/SectionTitle.vue';

  export default {
    components: {
      SectionTitle,
    },
  };
</script>
<style lang="scss" scoped>
  .locus-block {
    padding-bottom: 60px;
  }
  .list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 20px 10px;
    margin: -10px -5px;
    @include mq('sm') {
      padding: 20px;
    }
  }
  .item {
    padding: 10px 5px;
    max-width: 375px;
    @include mq('sm') {
      flex: 0 1 50%;
    }
    @include mq('lg') {
      flex: 0 1 33.33%;
    }
  }
  .card {
    height: 100%;
    background-color: #F8F8F8;
    padding: 10px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .cardLabel {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.9;
    text-align: center;
    padding-top: 1.2em;
    padding-bottom: 2em;
  }
</style>
